import React, { useEffect, useMemo } from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';
import PageFooter from 'components/common/general/layouts/PageFooter';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import ProductTemplateSidebar from 'components/common/rfq/ProductTemplateSidebar';
import { PRODUCT_TEMPLATE_CARD_DATA } from 'global/checklists-helpers/ProductTemplateChecklistHelper';
import RFQBenefitSummaryPageStore, {
  RFQBenefitSummaryPageStoreContext,
  useRFQBenefitSummaryPageStore,
} from 'store/pages/rfq/rfq-template/rfq-benefit-summary/pageStore';
import useRfqTemplate from 'global/hooks/useRfqTemplate';
import RFQBenefitSummary from 'components/rfq/product-template/rfq-benefit-summary';
import { observer } from 'mobx-react-lite';
import UploadDocumentModal from 'components/rfq/product-template/rfq-benefit-summary/UploadDocumentModal';
import { NarrowPageWrapperStyled } from '../../../../globalStyles';
import { StyledUploadButton } from './styles';

const BenefitSummaryPageHeader: React.FC = observer(() => {
  const { isTemplateInProgress, returnBack, openUploadDocumentModal } = useRFQBenefitSummaryPageStore();

  return (
    <>
      <PageHeader
        title={PRODUCT_TEMPLATE_CARD_DATA.BENEFIT_SUMMARY.title}
        subtitle={PRODUCT_TEMPLATE_CARD_DATA.BENEFIT_SUMMARY.text}
        onRedirect={returnBack}
        spacing={isTemplateInProgress ? 'WITH_ACTION_BELOW' : 'DEFAULT'}
      />
      {isTemplateInProgress && (
        <>
          <StyledUploadButton color="primary" size="large" onClick={openUploadDocumentModal}>
            Upload Document
          </StyledUploadButton>
          <UploadDocumentModal />
        </>
      )}
    </>
  );
});

const BenefitSummaryPageBody: React.FC = () => {
  const { getInitialData } = useRFQBenefitSummaryPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return <RFQBenefitSummary />;
};

const RFQBenefitSummaryPage: React.FC = observer(() => {
  const { templateId, pageType } = useRfqTemplate();

  const pageStore = useMemo(() => new RFQBenefitSummaryPageStore({ templateId, type: pageType }), []);

  return (
    <GlobalLayout
      leftSection={<ProductTemplateSidebar />}
      rightSection={
        <NarrowPageWrapperStyled>
          <RFQBenefitSummaryPageStoreContext.Provider value={pageStore}>
            <BenefitSummaryPageHeader />
            <BenefitSummaryPageBody />
            <PageFooter
              onBack={pageStore.returnBack}
              disableCompleteButton={!pageStore.isBenefitSummaryUploaded}
              onComplete={pageStore.isTemplateInProgress ? pageStore.completeStep : undefined}
            />
          </RFQBenefitSummaryPageStoreContext.Provider>
        </NarrowPageWrapperStyled>
      }
    />
  );
});

export default RFQBenefitSummaryPage;
